<template>
  <!-- 到货提醒 -->
  <div class="getGoods">
    <!-- 面包屑导航 -->
    <crumbs-bar @refresh="handleRefresh" :crumbsList="['系统配置',$route.meta.title]">
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input v-model="searchForm.name" style="width:200px;margin-right:5px" clearable
          placeholder="输入编号/名称"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%">
      <el-table-column
        align="center"
        prop="user"
        show-overflow-tooltip
        label="用户账号">
      </el-table-column>
      <el-table-column
        prop="buyer"
        align="center"
        show-overflow-tooltip
        label="求货用户">
      </el-table-column>
      <el-table-column
        prop="tel"
        label="电话"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="producer"
        label="厂家"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="repertory"
        label="库存"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="time"
        label="求货时间"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage"
      @hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>
  </div>
</template>

<script>

export default {
  name: 'getGoods',
  data() {
    return {
      /**表格数据 */
      //用户账号	求货用户	电话	名称	厂家	库存	求货时间
      tableData:[{
        user:"用户账号",
        buyer:"求货用户",
        tel:"电话",
        name:"名称",
        producer:"厂家",
        repertory:"库存",
        time:"求货时间"
      }],
      /**分页数据 */
      currPage:1,
      pageSize:20,
      allPage:0,
      /**搜索表单 */
      searchForm:{
        name:""
      },
    }
  },
  created() {
    this.getTableData()
  },
  components: {
    
  },
  methods:{
     /**获取表格 */
    getTableData(num){
      this.currPage = num == 1 ? 1 : this.currPage
      let data = {
        type: "GoodsRemind",
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Statistical";//存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url: "goods/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
        method:"post",
      }).then((res) => {
        console.log(res);
        this.allPage = res.recordCount
        this.tableData = []
        if(res.flag == 0){
          res.data.forEach(item => {
            this.tableData.push({
              user: item.username,
              buyer: item.name,
              tel: item.telphone,
              name: item.sub_title,
              producer: item.drug_factory,
              repertory: item.stock_quantity,
              time: item.AddTime,
            })
          })
        }
      })
    },
    /**刷新表格数据 */
    handleRefresh(){
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val){
      this.pageSize = val;
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val;
    },
  }
}
</script>

<style scoped>
.getGoods{
  width: 100%;
  height: 100%;
}
</style>
